export const DEPARTMENT_ANALYTICS_EVENTS = {
  DEPARTMENT_CREATE: "department-create",
  DEPARTMENT_UPDATE: "department-update",
  DEPARTMENT_DELETE: "department-delete",
  DEPARTMENT_STATUS_TOGGLE: "department-status-toggle",
  DEPARTMENT_FETCH: "department-fetch",
};
